import React from "react";
import styled from "styled-components";
import AspectImage from "./atoms/AspectImage";
import FadeIn from "./atoms/FadeIn";

import FemaleIcon from "../../assets/Female_Icon.svg";
import MaleIcon from "../../assets/Male_Icon.svg";

import { P } from "./typography";
import { r, getThemeColor } from "../utils";
import ReactMarkdown from "react-markdown";

const genders = { MaleIcon, FemaleIcon };

const Body = styled.div`
  display: flex;
  padding: 1rem 0rem;
  &:before {
    content: '';
    position: relative;
    top: .6rem;
    left: -4.605rem;
    width: 1rem;
    height: 1rem;
    min-width: 1rem;
    min-height: 1rem;
    background-color: ${getThemeColor("salmon")};
    border-radius: 50%;

    ${props => props.theme.media.mobile`
      left: -2.65rem;
    `};
  }
  &:nth-last-child(3) {
    padding-bottom: 3rem;
  }
  &:last-child {
    padding-top: 0rem;
  }
`;

const Text = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
`;

const Event = P.extend`
  font-size: ${({ bold }) => (bold ? "1.15rem" : "1rem")};
  font-weight: ${({ bold }) => (bold ? 500 : 400)};
  color: ${getThemeColor("greyTimeline")};
  padding-right: 1rem;
  a {
    color: ${getThemeColor("teal")};
  }
`;

const Date = P.extend`
  color: ${getThemeColor("greyTimeline")};
  ${props => props.theme.media.mobile`
    font-size:1.5rem;
    `};
`;

const ImageFull = styled.img`
  padding-right: 1rem;
  padding-top: .3rem;
  width: 1.5rem;
  height: 1.5rem;
`;

const DottedLine = styled.div`
  border-bottom: 2px dashed ${getThemeColor("greyDark")};
  position absolute;
  left: .5rem;
  right: -.5rem;
  top: 0;
  width: 100%;
  padding-top: 3.5rem;
`;

const Entry = ({ entry = {}, next = null, index }) => {
  const gap = Math.min(next && next.date ? next.date - entry.date : 0, 60),
    paddingBottom = index === 0 ? "1.2rem" : gap / 10 + "rem";
  console.log(gap);
  console.log(gap);
  return (
    <FadeIn style={{ paddingBottom }}>
      {entry.event === "Dotted Line"
        ? <DottedLine />
        : <Body>
            <ImageFull src={genders[entry.src]} />
            <Text>
              <Event bold={entry.bold}>
                <ReactMarkdown source={entry.event} />
              </Event>
              <Date>
                {entry.date}
              </Date>
            </Text>
          </Body>}
    </FadeIn>
  );
};

const Timeline = styled.div`
  min-width: 4px;
  width: 4px;
  background-color: ${getThemeColor("greyDark")};
  height: auto;

  &:before {
    content: '';
    position: absolute;
    width: .65rem;
    height: .65rem;
    background-color: grey;
    border-radius: 50%;
    ${r("left", ".8rem", "-.2rem")};
    top: -.1rem;
  }

  &:after {
    content: '';
    position: absolute;
    width: .65rem;
    height: .65rem;
    background-color: grey;
    border-radius: 50%;
    ${r("left", ".8rem", "-.2rem")};
    bottom: -0rem;
  }
`;

const Entries = styled.div`
  display: table-cell;
  ${r("padding", "1rem 4rem", "1rem 1rem 1rem 2rem")};
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  ${r("padding", "0rem 1rem", "0")};
`;

export default ({ entries = [], title = "" }) =>
  <Container>
    <Timeline />
    <Entries>
      {entries.map((entry, index) =>
        <Entry
          entry={entry}
          next={index < entries.length - 1 ? entries[index + 1] : null}
          index={index}
        />
      )}
    </Entries>
  </Container>;



// WEBPACK FOOTER //
// ./src/components/Timeline.js